import { useEffect } from 'react';
import { useState } from 'react';
import { Grid, IconButton, ListItem, Paper, Table, TableCell, TableHead, TableRow, Tooltip, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import theme from '../../../../app/config/themaConfig';
import { FaFilter } from "react-icons/fa6";
import { IoCloseCircleSharp } from "react-icons/io5";
import { useDispatch } from "react-redux";
import FilterModal from './FilterModal';
import { getUsuariosMulti,getlistid } from '../../../domain/api/EvbiApi';
import { USER_ID } from '../../../../app/api-client/constants';
import PostAddIcon from '@material-ui/icons/PostAdd';
import { useHistory } from 'react-router-dom';
import MigaPan from '../../../../app/orussystem/component/MigaPan';




const useStyles = makeStyles((theme) => ({
    paper: {
        borderRadius: '30px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
        padding: theme.spacing(2),
        backgroundColor: '#F5F8F9',
        marginTop: '5%'
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: 15,
        padding: theme.spacing(1),
    },
    input: {
        marginLeft: '1%',
        flex: 1,
    },
    iconButton: {
        padding: 10,
        marginLeft: '30%'
    },
    iconfilter: {
        padding: 10,
        marginLeft: '2%',
        marginRight: '2%'
    },
    TableCell: {
        color: '#0088FE',
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
        fontWeight: 'bold',
        fontSize: '17px',

    },

    card: {
        padding: theme.spacing(3),
        marginBottom: theme.spacing(2),
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
        marginTop: '0%',
        marginBottom: '5px',
        height: 'auto',
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
    },
    cardActions: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    title: {
        backgroundColor: 'white',
        padding: '16px',
        display: 'flex',
        justifyContent: 'Center',
        alignItems: 'center',
        fontWeight: 'bold'
    },
    filterCard: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#FFFFFF',
        border: '1px solid #E0E0E0',
        borderRadius: '10px',
        padding: '8px',
        marginTop: '8px',
        width: '15%',
        transition: 'transform 0.3s ease', 
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', 
        cursor: 'pointer', 
        '&:hover': {
            transform: 'translateY(-5px)', 
            boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2)',
        },
    },
}));

export const MultifiltrosGeneral = ({ textStyle }) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [grupo] = useState('');
    const [ArrayEvbis, setArrayEvbis] = useState('');
    const [ArrayUsers, setArrayUsers] = useState([]);

    const [page] = useState(0);
    const [rowsPerPage] = useState(10);

    const id_user_login = localStorage.getItem(USER_ID)
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [genero, setGenero] = useState('');
    const [IMC, setIMC] = useState('-');
    const [PGC, setPGC] = useState('-');
    const [presion, setPresion] = useState('-');
    const [edadMinima, setEdadMinima] = useState(0);
    const [edadMaxima, setEdadMaxima] = useState(0);
    const [pesoMinimo, setPesoMinimo] = useState(0);
    const [pesoMaximo, setPesoMaximo] = useState(0);
    const [alturaMinima, setAlturaMinima] = useState(0);
    const [alturaMaxima, setAlturaMaxima] = useState(0);
    const [selectedEvbis, setSelectedEvbis] = useState([]);
    const [Evbisiniciales, setEvbisiniciales] = useState([]);
    const [selectedEvbisNames, setSelectedEvbisNames] = useState([]);
    const [openFilterModal, setOpenFilterModal] = useState(false);
    const primaryColor = theme.palette.primary.main;
    const history = useHistory();
    const dispatch = useDispatch();


    const requestBody = {
        evbis: selectedEvbis,
        genders: genero ? [genero] : [],
        minAge: edadMinima !== 0 ? Number(edadMinima) : -1,
        maxAge: edadMaxima !== 0 ? Number(edadMaxima) : -1,
        minHeight: alturaMinima !== 0 ? Number(alturaMinima) : -1,
        maxHeight: alturaMaxima !== 0 ? Number(alturaMaxima) : -1,
        minWeight: pesoMinimo !== 0 ? Number(pesoMinimo) : -1,
        maxWeight: pesoMaximo !== 0 ? Number(pesoMaximo) : -1,
        imc: IMC !== '-' ? Number(IMC) : -1,
        pgc: PGC !== '-' ? Number(PGC) : -1,
        bloodPressure: presion !== '-' ? Number(presion) : -1,
        page: page,
        size: rowsPerPage
    };

    const fetchData = async () => {
        try {
            const basculas = await getlistid(dispatch, '', id_user_login, '', '');
            setArrayEvbis(basculas.content);

            // Establecer Evbisiniciales con los IDs de ArrayEvbis
            const evbisIds = basculas.content.map((evbi) => evbi.id);
            setSelectedEvbis(evbisIds);
            setEvbisiniciales(evbisIds)
        } catch (error) {
            console.error('Error al obtener datos: ', error);
            setLoading(false);
        }
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const basculas = await getlistid(dispatch, '', id_user_login, '', '');
                setArrayEvbis(basculas.content);

                // Establecer Evbisiniciales con los IDs de ArrayEvbis
                const evbisIds = basculas.content.map((evbi) => evbi.id);
                setSelectedEvbis(evbisIds);
                setEvbisiniciales(evbisIds)
            } catch (error) {
                console.error('Error al obtener datos: ', error);
                setLoading(false);
            }
        };
        fetchData();

    }, [dispatch, id_user_login]);



    const handleClosefilter = () => {
        setOpenFilterModal(false)

    };


    //multifiltro
    const handleOpenFilterModal = () => {
        setOpenFilterModal(true);
    };


    const IMC_NAMES = {
        3: 'Bajo',
        4: 'Normal',
        5: 'Sobre peso',
        6: 'Obesidad clase l',
        7: 'Obesidad clase ll',
        8: 'Obesidad clase lll',
    };
    const PGC_NAMES = {
        9: 'Bajo',
        10: 'Normal',
        11: 'Alto',
        12: 'Muy alto',
    };
    const PRESION_NAMES = {
        13: 'Hipotension',
        14: 'Optima',
        15: 'Normal',
        16: 'Sospecha',
        17: 'Hipertension arterial',
    };


    useEffect(() => {
        const fetchFilter = async () => {
            try {
                setLoading(true);
                const Usuarios = await getUsuariosMulti(dispatch, requestBody);
                setArrayUsers(Usuarios.content);

            } catch (error) {
                console.error('Error al obtener datos: ', error);
            } finally {
                setLoading(false);
            }
        };

        let timer;
        if (selectedEvbis.length > 0) {
            setLoading(false);
            fetchFilter();

            timer = setTimeout(() => {

                setLoading(false);
            }, 60000);
        }

        return () => {
            clearTimeout(timer);
        };
    }, [page, rowsPerPage, selectedEvbis, genero, edadMinima, edadMaxima, alturaMinima, alturaMaxima, pesoMinimo, pesoMaximo, IMC, PGC, presion, selectedFilters, dispatch, requestBody]);


    function formatDateTime(dateTimeString) {
        const date = new Date(dateTimeString);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${year}/${month}/${day} ${hours}:${minutes}`;
    }

    const goToHistorialUser = (row) => {
        const params = {
            busqueda: "multifiltro"
        };
        let identificacion = row.numerodocumento === null ? '0000' : row.numerodocumento;
        history.push(`/mediciones/user/bascula/idbascula/historial/${identificacion}`, params);
    };
    return (
        <>
         <Grid item xs={12} >
                <br></br>
                <br></br>
                <MigaPan
                    namePage="Multifiltro"
                    to="/"
                    namePage2="Datos"
                    to2="/Datos"

                >
                    Home
                </MigaPan>
            </Grid>
            <Paper className={classes.paper} style={{ height: '100%', width: '100%',marginTop:'0%' }}>
                <div style={{ marginLeft: '30%', width: '200%', marginTop: '1%' }}>

                </div>
                <>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', width: '100%', marginBottom: '2%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%', maxWidth: '1195px' }}>
                            {/* Icono de filtro */}
                            <IconButton className={classes.iconfilter} onClick={handleOpenFilterModal}>
                                <FaFilter style={textStyle} />
                            </IconButton>
                            {/* Filter Card */}
                            {selectedEvbisNames !== '' && (
                                <div className={classes.filterCard} style={{ width: '25%' }}>
                                    <Tooltip title="Evbi">

                                        <p style={{ color: primaryColor, fontSize: '16px', margin: 0 }}>{selectedEvbisNames}</p>
                                    </Tooltip>
                                    <IoCloseCircleSharp style={{ textAlign: 'right' }}
                                        onClick={() => {
                                            setSelectedEvbis([]);
                                            fetchData()
                                            setSelectedEvbisNames('');
                                            setSelectedFilters(selectedFilters.filter(filter => filter !== 'Evbi'));
                                        }} />
                                </div>
                            )}
                            {genero !== '' && (
                                <div className={classes.filterCard}>
                                    <Tooltip title="genero">

                                        <p style={{ color: primaryColor, fontSize: '16px', margin: 0 }}>{genero ?
                                            genero === 'F' ? 'Femenino' :
                                                genero === 'M' ? 'Masculino' :
                                                    genero === '-' ? 'Todos' :
                                                        null
                                            : null}</p>
                                    </Tooltip>
                                    <IoCloseCircleSharp style={{ textAlign: 'right' }}
                                        onClick={() => {
                                            setGenero('');
                                            setSelectedFilters(selectedFilters.filter(filter => filter !== 'genero'));
                                        }} />
                                </div>
                            )}
                            {alturaMinima !== 0 && (
                                <div className={classes.filterCard} style={{ width: '13%' }}>
                                    <Tooltip title={`Altura min: ${alturaMinima}`}>
                                        <div>
                                            <p style={{ color: primaryColor, fontSize: '16px', margin: 0 }}>Altura min: {alturaMinima}</p>

                                        </div>
                                    </Tooltip>
                                    <IoCloseCircleSharp style={{ textAlign: 'right' }}
                                        onClick={() => {
                                            setAlturaMinima(0);
                                            setSelectedFilters(selectedFilters.filter(filter => filter !== 'altura'));
                                        }} />
                                </div>
                            )}
                            {alturaMaxima !== 0 && (
                                <div className={classes.filterCard} style={{ width: '13%' }}>
                                    <Tooltip title={`Altura max: ${alturaMaxima}`}>
                                        <div>
                                            <p style={{ color: primaryColor, fontSize: '16px', margin: 0 }}>Altura max: {alturaMaxima}</p>

                                        </div>
                                    </Tooltip>
                                    <IoCloseCircleSharp style={{ textAlign: 'right' }}
                                        onClick={() => {
                                            setAlturaMaxima(0);
                                            setSelectedFilters(selectedFilters.filter(filter => filter !== 'altura'));
                                        }} />
                                </div>
                            )}
                            {edadMinima !== 0 && (
                                <div className={classes.filterCard} style={{ width: '12%' }}>
                                    <Tooltip title={`Edad min: ${edadMinima}`}>
                                        <div>
                                            <p style={{ color: primaryColor, fontSize: '16px', margin: 0 }}>Edad min: {edadMinima}</p>

                                        </div>
                                    </Tooltip>
                                    <IoCloseCircleSharp style={{ textAlign: 'right' }}
                                        onClick={() => {
                                            setEdadMinima(0);
                                            setSelectedFilters(selectedFilters.filter(filter => filter !== 'edad'));
                                        }} />
                                </div>
                            )}
                            {edadMaxima !== 0 && (
                                <div className={classes.filterCard} style={{ width: '12%' }}>
                                    <Tooltip title={` Edad max: ${edadMaxima}`}>
                                        <div>

                                            <p style={{ color: primaryColor, fontSize: '16px', margin: 0 }}>Edad max: {edadMaxima}</p>
                                        </div>
                                    </Tooltip>
                                    <IoCloseCircleSharp style={{ textAlign: 'right' }}
                                        onClick={() => {
                                            setEdadMaxima(0);

                                            setSelectedFilters(selectedFilters.filter(filter => filter !== 'edad'));
                                        }} />
                                </div>
                            )}
                            {pesoMinimo !== 0 && (
                                <div className={classes.filterCard} style={{ width: '12%' }}>
                                    <Tooltip title={`Peso min: ${pesoMinimo}`}>
                                        <div>
                                            <p style={{ color: primaryColor, fontSize: '16px', margin: 0 }}>Peso min: {pesoMinimo}</p>

                                        </div>
                                    </Tooltip>
                                    <IoCloseCircleSharp style={{ textAlign: 'right' }}
                                        onClick={() => {
                                            setPesoMinimo(0);
                                            setSelectedFilters(selectedFilters.filter(filter => filter !== 'peso'));
                                        }} />
                                </div>
                            )}
                            {pesoMaximo !== 0 && (
                                <div className={classes.filterCard} style={{ width: '12%' }}>
                                    <Tooltip title={`Peso max: ${pesoMaximo}`}>
                                        <div>

                                            <p style={{ color: primaryColor, fontSize: '16px', margin: 0 }}>Peso max: {pesoMaximo}</p>
                                        </div>
                                    </Tooltip>
                                    <IoCloseCircleSharp style={{ textAlign: 'right' }}
                                        onClick={() => {

                                            setPesoMaximo(0);
                                            setSelectedFilters(selectedFilters.filter(filter => filter !== 'peso'));
                                        }} />
                                </div>
                            )}
                            {IMC !== '-' && (
                                <div className={classes.filterCard} style={{ width: '20%' }}>
                                    <Tooltip title={`IMC : ${IMC}`}>
                                        <div>
                                            <p style={{ color: primaryColor, fontSize: '16px', margin: 0 }}>IMC: {IMC_NAMES[IMC]}</p>

                                        </div>
                                    </Tooltip>
                                    <IoCloseCircleSharp style={{ textAlign: 'right' }}
                                        onClick={() => {
                                            setIMC('-');
                                            setSelectedFilters(selectedFilters.filter(filter => filter !== 'imc'));
                                        }} />
                                </div>
                            )}
                            {PGC !== '-' && (
                                <div className={classes.filterCard} style={{ width: '20%' }}>
                                    <Tooltip title={`PGC : ${PGC}`}>
                                        <div>
                                            <p style={{ color: primaryColor, fontSize: '16px', margin: 0 }}>PGC: {PGC_NAMES[PGC]}</p>

                                        </div>
                                    </Tooltip>
                                    <IoCloseCircleSharp style={{ textAlign: 'right' }}
                                        onClick={() => {
                                            setPGC('-');
                                            setSelectedFilters(selectedFilters.filter(filter => filter !== 'pgc'));
                                        }} />
                                </div>
                            )}
                            {presion !== '-' && (
                                <div className={classes.filterCard} style={{ width: '20%' }}>
                                    <Tooltip title={`presion : ${presion}`}>
                                        <div>
                                            <p style={{ color: primaryColor, fontSize: '16px', margin: 0 }}>Presión: {PRESION_NAMES[presion]}</p>

                                        </div>
                                    </Tooltip>
                                    <IoCloseCircleSharp style={{ textAlign: 'right' }}
                                        onClick={() => {
                                            setPresion('-');
                                            setSelectedFilters(selectedFilters.filter(filter => filter !== 'presion'));
                                        }} />
                                </div>

                            )}

                        </div>


                    </div>

                    <Grid item xs={12}>
                        <Table>
                            <TableHead color='primary'>
                                <TableRow color='primary'>
                                    <TableCell className={classes.TableCell} style={{ paddingLeft: '3%', width: '6.5%', color: primaryColor }}>Identificacion</TableCell>
                                    <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '4%', color: primaryColor }}>Nombre</TableCell>
                                    <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '3%', color: primaryColor }}>Celular</TableCell>
                                    <TableCell className={classes.TableCell} style={{ paddingLeft: '1%', width: '3%', color: primaryColor }}>Género</TableCell>
                                    <TableCell className={classes.TableCell} style={{ paddingLeft: '2%', width: '3%', color: primaryColor }}>Imc</TableCell>
                                    <TableCell className={classes.TableCell} style={{ paddingLeft: '2%', width: '3%', color: primaryColor }}>Pgc</TableCell>
                                    <TableCell className={classes.TableCell} style={{ paddingLeft: '2%', width: '3%', color: primaryColor }}>Peso</TableCell>
                                    <TableCell className={classes.TableCell} style={{ paddingLeft: '0.5%', width: '3%', color: primaryColor }}>Altura</TableCell>
                                    <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '3%', color: primaryColor }}>Presión Arterial (mmHg)</TableCell>
                                    <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '3%', color: primaryColor }}>Fecha Última Medicion</TableCell>
                                    <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '3%', color: primaryColor }}>Historico</TableCell>

                                </TableRow>
                            </TableHead>
                        </Table>
                    </Grid>

                    {!loading && !ArrayUsers && (
                        <TableRow>
                            <TableCell colSpan={3}>No se encontraron datos.</TableCell>
                        </TableRow>
                    )}
                    {!loading && (
                        // Mapeo sobre las propiedades filtradas
                        ArrayUsers.map((user, index) => (
                            <Paper key={index} className={classes.card}>
                                <Grid container spacing={1}>
                                    <Grid item style={{ fontWeight: 'bold', fontSize: '16px', width: '12%', whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
                                        {user.numerodocumento ? user.numerodocumento : '-'}
                                    </Grid>
                                    <Grid item style={{ fontWeight: 'bold', fontSize: '16px', width: '12%', whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
                                        {user.firstname ? user.firstname : '-'}
                                    </Grid>

                                    <Grid style={{ fontWeight: 'bold', fontSize: '16px', whiteSpace: 'normal', width: '11%' }}>
                                        {user.celular ? user.celular : '-'}
                                    </Grid>

                                    <Grid item style={{ fontWeight: 'bold', fontSize: '16px', width: '8%', whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
                                        {user.genero === 'F' ? 'Femenino' : user.genero === 'M' ? 'Masculino' : '-'}
                                    </Grid>

                                    <Grid item style={{ fontWeight: 'bold', fontSize: '16px', width: '6.5%', paddingLeft: '3%' }}>
                                        {user.imc ? Math.floor(user.imc * 10) / 10 : '-'}
                                    </Grid>

                                    <Grid item style={{ fontWeight: 'bold', fontSize: '16px', width: '6.5%', paddingLeft: '3%' }}>
                                        {user.igc ? Math.floor(user.igc * 10) / 10 : '-'}
                                    </Grid>
                                    <Grid item style={{ fontWeight: 'bold', fontSize: '16px', width: '6.5%', paddingLeft: '3%' }}>
                                        {user.peso ? Math.floor(user.peso * 10) / 10 : '-'}
                                    </Grid>
                                    <Grid item style={{ fontWeight: 'bold', fontSize: '16px', width: '6.5%', paddingLeft: '3%' }}>
                                        {user.altura ? user.altura : '-'}
                                    </Grid>
                                    <Grid item style={{ fontWeight: 'bold', fontSize: '16px', width: '10%', paddingLeft: '3%' }}>
                                        {user.sistolica ? Math.floor(user.sistolica * 10) / 10 : '-'} / {user.diastolica ? Math.floor(user.diastolica * 10) / 10 : '-'}
                                    </Grid>
                                    <Grid item style={{ fontWeight: 'bold', fontSize: '16px', width: '12%', paddingLeft: '0%' }}>
                                        {user.dateloginlatest ? formatDateTime(user.dateloginlatest) : '-'}
                                    </Grid>
                                    <Grid item style={{ fontWeight: 'bold', fontSize: '16px', width: '3%', paddingLeft: '2%' }}>
                                        <ListItem button onClick={() => goToHistorialUser(user)}>
                                            <Tooltip title="historial de usuario" aria-label="right-end">
                                                <PostAddIcon style={{ marginLeft: '5%', color: primaryColor }} />
                                            </Tooltip>
                                        </ListItem>
                                    </Grid>


                                </Grid>
                            </Paper>
                        ))
                    )}
                    {loading && (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
                            <CircularProgress />
                        </div>
                    )}

                </>





            </Paper>

            <FilterModal
                open={openFilterModal}
                handleClose={handleClosefilter}
                primaryColor={primaryColor}
                ArrayEvbis={ArrayEvbis}
                setSelectedEvbis={setSelectedEvbis}
                setSelectedFilters={setSelectedFilters}
                selectedFilters={selectedFilters}
                selectedEvbis={selectedEvbis}
                genero={genero}
                setGenero={setGenero}
                alturaMinima={alturaMinima}
                setAlturaMinima={setAlturaMinima}
                alturaMaxima={alturaMaxima}
                setAlturaMaxima={setAlturaMaxima}
                edadMinima={edadMinima}
                setEdadMinima={setEdadMinima}
                edadMaxima={edadMaxima}
                setEdadMaxima={setEdadMaxima}
                pesoMinimo={pesoMinimo}
                setPesoMinimo={setPesoMinimo}
                pesoMaximo={pesoMaximo}
                setPesoMaximo={setPesoMaximo}
                IMC={IMC}
                setIMC={setIMC}
                PGC={PGC}
                setPGC={setPGC}
                presion={presion}
                setPresion={setPresion}
                selectedEvbisNames={selectedEvbisNames}
                setSelectedEvbisNames={setSelectedEvbisNames}
                Evbisiniciales={Evbisiniciales}
            />




        </>
    );

};

